'use strict';

var Backbone = require('dibs-backbone');

var ModalEmail = module.exports = Backbone.BaseView.extend();

var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var SV = require('server-vars');
var mobileCheck = require('bunsen/helpers/mobileCheck');
var ModalEmailTracking = require('./tracking');
var User = require('../../models/User');
var cssVars = require('../../core/commonjs/cssVars').breakpoints;
var price = require('../../mixins/commonjs/price');
var authModalLoader = require('../../../auth/authModalLoader').default;
var findNamespaceValue = require('find-namespace-value');
var Conversation = require('bunsen/models/usercomm/Conversation');
var AnchorLists = require('bunsen/collections/identity/AnchorLists');
var SendToFriendView = require('./views/SendToFriendView');
var ModalEmailModel = require('./models/ModalEmailModel');
var requ = require('reku');
var simplyDeferred = require('simply-deferred');
var Deferred = simplyDeferred.Deferred;

require('bunsen/libraries/plugins/jquery.simpler-modal');

_.extend(ModalEmail.prototype, price, {
    $modal: {},
    el: '#modalOverlay',
    viewEvents: {
        'showSuccess': 'showSuccess',
        'showServerError': 'showServerError',
        'hideModal': 'hideModal',
        'showModal': 'showModal'
    },
    subViewConfig: {
        friend: {
            construct: SendToFriendView,
            singleton: true
        }
    },
    events: {
        'click .show-login': function (e) {
            e.stopImmediatePropagation();

            // close the email modal
            this.closeModal();

            // open the login modal
            authModalLoader.show({
                action: authModalLoader.constants.LOGIN,
                ga: {
                    label: 'login link - contact dealer thank you page'
                }
            });
        },
        'click .show-register': function (e) {
            e.stopImmediatePropagation();

            // close the email modal
            this.closeModal();

            // open the registration modal
            authModalLoader.show({
                action: authModalLoader.constants.REGISTER,
                email: this.modal.get('message.emailDataMap.from_email'),
                ga: {
                    label: 'register link -email a friend thank you page'
                }
            });
        }
    },
    /**
     *
     * @param {object} options
     * @param {string} options.type "dealer" or "friend"
     * @param {string} options.pageType "item" or "seller"
     * @param {string} options.linkLocation Where the link click occured (tracking)
     **/
    initialize: function (options) {
        var ThisModalEmailTracking = ModalEmailTracking;
        this.options = options || {};
        this.$body = $('body');
        this.model = new ModalEmailModel({
            isMobile: cssVars.integer && $(window).width() <= cssVars.integer['mobile-large-landscape'],
            isDesktop: cssVars.integer && $(window).width() >= cssVars.integer.desktop,
            pageSV: options.pageData || SV.get('data'),
            type: options.type,
            pageType: options.pageType,
            queryString: window.location.search,
            user: {
                id: User.getUserId(),
                profile: User.getUserProfile()
            },
            tracking: {
                linkLocation: options.linkLocation
            }
        });
        this.$spinner = $('<div>').addClass('email-modal-spinner-container')
            .append($('<img>').attr('src', findNamespaceValue('settings.assets.loadingGif', SV)));
        if (!this.$modal.fn) {
            this.$modal = {
                fn: $.fn.dibsModal()
            };
        }

        if (_.isFunction(this.$modal.fn.close)) {
            $.subscribe('modal:close', function () {
                // MCPERSON-294 clean up modal classes after close
                this.$modal.fn.close.call(this);
                this._tracking.resetPageViewVars();
                $.unsubscribe('modal:close');
            }.bind(this));
        }
        this._tracking = new ThisModalEmailTracking();
    },
    show: function (data, trackOnLoad) {
        if (!this._ajaxContent) {
            this.load(data, trackOnLoad);
        } else {
            //doesn't seem like this ever happens
            this.$modal.fn.update('email-modal').show();
        }
    },
    /**
     * loads the content of the email modal via ajax
     * @param data
     * @returns {*} promise object for ajax call
     */
    load: function (data, trackOnLoad) {
        var self = this;
        var type = this.model.get('type');
        var conversation = new Conversation();
        var anchorLists = new AnchorLists();
        var dealerPk;
        var gotConversationList;
        var status;
        var vpvString;

        data = data || {};
        dealerPk = data.dealerPk || SV.get('data.dealerPk') || SV.get('contactSellerData.id');

        this.showSpinner();
        $.extend(true, data, {type: type});

        gotConversationList = anchorLists.fetchSellerOnList(dealerPk, AnchorLists.listNames.OPOP, 'SELLER_POLICY').then(function () {
            if (anchorLists.length > 0) {
                return undefined;
            }
            // old dealer policy (pre Aug 2015)
            if (!User.getUserId()) {
                // buyer is logged out -- will not check conversation history
                this.showShareEmailCheckbox = true;
                return undefined;
            }
            return conversation.fetchConversationForBuyerAndItem({
                buyerId: User.getUserId(),
                itemId: SV.get('data.pk')
            }).then(null, function (response) {
                if (response.status === 404) {
                    // conversation is not found (buyer has not contacted dealer about this item)
                    this.showShareEmailCheckbox = true;
                }
                return new Deferred().resolve();
            }.bind(this));
        }.bind(this), function () {
            return new Deferred().resolve();
        });


        return simplyDeferred.when(gotConversationList, requ({
            url: this.model.getAjaxContentPath(),
            dataType: 'json',
            data: data
        })).done(function (convResp, modalContentResp) {
            this._ajaxContent = _.chain(modalContentResp).result('shift').result('data').value();
            this.render();
            // FINDING-3602 prices being loaded using PriceLoader instance in pdp.js
            $.publish('modal-email:load', [this.model.get('type'), this.model.get('shouldShowPrice'), this.model.get('pageType')]);
            status = SV.get('tracking.initialDataLayerInfo.pageSubType');
            vpvString = SV.get('modalData.vpvString');
            vpvString += "&status=" + status.toLowerCase();
            this._tracking.firePageViewGAEvent(vpvString);
            if (trackOnLoad) {
                this._tracking.fireCommunicationGAEvent({
                    linkLocation: self.model.get('tracking.linkLocation'),
                    fromForm: false,
                    itemPk: SV.get('modalData.itemPk')
                });
            }
        }.bind(this));
    },
    showSpinner: function () {
        this.$modal.fn.update('email-modal', this.$spinner).show();
    },
    showSuccess: function () {
        var type = this.model.get('type');
        if (type === 'friend') {
            this.$('.email-send-container').hide();
        } else {
            this.form.$sendContainer.hide();
        }
        this.form.$successMessage.removeClass('is-hidden');
        if (!User.loggedIn()) {
            this.form.$successSubtext.removeClass('is-hidden');
        }
        $.publish('modal-email:success', [type]);
        this._tracking.firePageViewGAEvent(SV.get('modalData.vpvSuccessString'));
        this._tracking.fireCommunicationGAEvent({
            linkLocation: this.model.get('tracking.linkLocation'),
            fromForm: true,
            emailShared: this.$('#isShowSenderEmail').is(":checked"),
            itemPk: SV.get('modalData.itemPk')
        });
    },
    showServerError: function () {
        this.form.$serverErrorMsg.show();
    },
    /**
     * different implementation than usual backbone view.
     * content is loaded via ajax, so rather than render it
     * we'll map it to subviews for internal use.
     */
    render: function () {
        var type = this.model.get('type');

        if (!this._ajaxContent) {
            return this;
        }
        this.$modal.fn.update('email-modal', this._ajaxContent); // this._ajaxContent will add additional serverVars, so watch out!
        this.$modal.fn.show();

        if (this.showShareEmailCheckbox) {
            this.$('.dealer-modal-opt-in-container').removeClass('is-hidden');
        }
        this.form = this.subs.add(this.model.get('type'), {model: this.model}).newest;
        switch (this.model.get('pageType')) {
            case 'item':
                this.$el.addClass('email-item-modal');
                break;
            case 'seller':
                this.$el.addClass('seller-sf');
                break;
        }
        // note: used toggleClass() here because class remains on next modal that is opened
        this.$el.toggleClass('dealer-modal', type === 'dealer');
        this.$el.toggleClass('friend-modal', type === 'friend');
        this.updatePrices(true, this.model.get('currency'));
        this.form.initValidation();
        this.handleMobileKeyboard();
        return this;
    },
    hideModal: function () {
        this.$modal.fn.enableScrolling();
        this.$modal.fn.hideModal();
    },
    showModal: function () {
        this.$modal.fn.showModal();
    },
    //FINDING-2131: deals with iOS bug where fixed position elements don't get resized when keyboard is open
    handleMobileKeyboard: function () {
        var self = this;
        var modalContentHeight;
        if (mobileCheck.iOS()) {
            modalContentHeight = this.$el.height();
            this.form.$el.find(':input').blur(function () {
                if (mobileCheck.iPad()) {
                    self.$body.bind('touchmove.modal', function (e) {
                        e.preventDefault();
                    });
                } else {
                    self.$el.css({ height: modalContentHeight, 'position': 'absolute' });
                }
            });
            this.form.$el.find(':input').blur(function () {
                if (mobileCheck.iPad()) {
                    self.$body.unbind('touchmove.modal');
                } else {
                    self.$el.css({ height: '', 'position': 'fixed' });
                }
            });
        }
    },
    closeModal: function () {
        $.publish('modal:close');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/modalEmail/ModalEmailBase.js
// module id = 1186
// module chunks = 4 7 12